import { http } from "../http";

/**
 * Admin uploaded documents attached to a peer profile.
 *
 * The file binary is uploaded through the shared `upload` endpoint (see
 * commonService.uploadFile) which returns the stored S3 fileName; this api
 * persists/reads the document metadata around that file.
 */
export class AdminUploadsApi {
  private static INSTANCE = new AdminUploadsApi();

  static get instance() {
    return this.INSTANCE;
  }

  // GET the list of admin uploaded documents for a peer (keyed by email)
  public getPeerDocuments(email: string) {
    const endPoint = `cfss/peers/document?email=${encodeURIComponent(email)}`;
    const headers = http.getTokenHeaders();
    return http.get(endPoint, headers).then((response) => {
      return response.data;
    });
  }

  // POST a new admin uploaded document (metadata) for a peer
  public createPeerDocument(payload: any) {
    const endPoint = `cfss/peers/document`;
    const headers = http.getTokenHeaders();
    return http.post(endPoint, headers, payload).then((response) => {
      return response;
    });
  }

  // PUT toggle the visible-to-peer flag of a document
  public updateDocumentVisibility(id: number, visibleToPeer: boolean) {
    const endPoint = `cfss/peers/document/visibility`;
    const headers = http.getTokenHeaders();
    return http
      .put(endPoint, headers, { id, visibleToPeer })
      .then((response) => {
        return response;
      });
  }

  // DELETE a document (soft delete — the row and its S3 file are retained)
  public deletePeerDocument(id: number) {
    const endPoint = `cfss/peers/document?id=${id}`;
    const headers = http.getTokenHeaders();
    return http.delete(endPoint, headers).then((response) => {
      return response;
    });
  }
}

export const adminUploadsApi = AdminUploadsApi.instance;
